/*--------------------------------------
 ANIMATIONS
 --------------------------------------*/
Animations = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        //FADEINUP
        $('[data-fadeinup]').each(function () {
            var tw = new gsap.timeline();
            tw.from(this, 1.7, { ease: Expo.easeOut, y: 20 })
                .to(this, 1, { opacity: 1 }, 0);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: .92,
                reverse: true
            })
                .setTween(tw)
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadein]').each(function () {
            var tw = new gsap.timeline();
            tw.to(this, 1, { opacity: 1 });

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            })
                .setTween(tw)
                //.addIndicators()
                .addTo(controller);
        });


    }
};

/*--------------------------------------
                 OTHERS 
 --------------------------------------*/
dynamicViewHeight = {
    init: function () {
        updateViewHeight();

        //window.addEventListener("resize", updateViewHeight);
        window.addEventListener("orientationchange", updateViewHeight);

        function updateViewHeight() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
    }
};

/*----------------------
       MENU
---------------------- */
Menu = {
    init: function () {
        $(".section-header .btn-submenu").on("click", function (e) {
            e.preventDefault();
            var parent_this = $(this).closest(".header-menu__nav--lists");
            $('.header-menu__nav--lists').not(parent_this).removeClass('open');
            parent_this.toggleClass("open");
            $("body").removeClass("open-submenu-home");
            $("body").toggleClass("open-submenu");

        });

        $(".section-header-home .btn-submenu").on("click", function (e) {
            e.preventDefault();
            var parent_this = $(this).closest(".header-menu__nav--lists");
            $('.header-menu__nav--lists').not(parent_this).removeClass('open');
            parent_this.toggleClass("open");
            $("body").removeClass("open-submenu");
            $("body").toggleClass("open-submenu-home");
        });



        $("body").on("click", function (e) {
            if (!$(e.target).closest('.btn-submenu, .submenu').length) {
                $('.header-menu__nav--lists').removeClass('open');
                $("body").removeClass("open-submenu");
            }
        });





        // Logo home: toggle clásico (como antes) — hide hero text / show header logo
        $(document).on("scroll", function () {
            if ($(document).scrollTop() > 50) {
              $("body.index .swiper-sliderbig__text").addClass("hide");
              $("body.index .section-header .header-menu__logo__title").addClass("show");
              $("body.index .section-header").addClass("header-black");
            }
            else {
              $("body.index .swiper-sliderbig__text").removeClass("hide");
              $("body.index .section-header .header-menu__logo__title").removeClass("show");
              $("body.index .section-header").removeClass("header-black");
            }
          });
    }
};

/*----------------------
       MENU MOBILE
---------------------- */
MenuMobile = {
    init: function () {
        $(".btn-submenu-mobile").on("click", function(e){
            e.preventDefault();
            $(this).closest(".header-mobile__nav--lists").toggleClass("open");
        });

        $(".btn-menu-mobile").on("click", function(e){
            e.preventDefault();
            $("body").toggleClass("open-menu-mobile");
        });
       
    }
};

/*----------------------
SEARCH
----------------------*/
Search = {
    init: function () {

        //OPEN IN MENU
        $(".section-header .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header .search-input").addClass("open");
            $("body").removeClass("open-search-home");
            $("body").addClass("open-search");
            $(".section-header .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header .search-input input.input-search").on("input", function () {
            $(".section-header .search-input__content").addClass("start");
        });

        //OPEN IN MENU HOME
        $(".section-header-home .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header-home .search-input").addClass("open");
            $("body").removeClass("open-search");
            $("body").addClass("open-search-home");
            $(".section-header-home .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header-home .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header-home .search-input input.input-search").on("input", function () {
            $(".section-header-home .search-input__content").addClass("start");
        });


        //CLOSE
        $(".btn-close-search").on("click", function () {
            $(".search-input").removeClass("open");
            $(".search-input input.input-search").val("");
            $(".search-input__content").removeClass("start");
            $("body").removeClass("open-search");
            $("body").removeClass("open-search-home");
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.btn-search, .search-input').length) {
                $(".search-input").removeClass("open");
                $(".search-input input.input-search").val("");
                $(".search-input__content").removeClass("start");
                $("body").removeClass("open-search");
                $("body").removeClass("open-search-home");
            }
        })
    }
};

$(document).ready(function () {
    Animations.init();
    Menu.init();
    dynamicViewHeight.init();
    Search.init();
    MenuMobile.init();
});
$(document).on('shopify:section:load', function (event) {
    Animations.init();
    Menu.init();
    dynamicViewHeight.init();
    Search.init();
    MenuMobile.init();
});